import React from "react";
import "./ServersSection.css";

export default function ServersSection() {
  return (
    <div className="ServersSection py-5 pb0 pt0">
      <div className="container py-5  pb0 pt0">
        <div className="row">
          <div className="col-lg-6"></div>
          <div className="col-lg-6">
            <div className="main   ms0 me0 ps0 pe0 ">
              <p className="paragraph1 py-3 pb-2 fs-5 fw-bold ">Servers</p>
              <h1 className="fw-bold ">
                Huge global network of fast VPN servers
              </h1>

              <p className="text-secondary pt-4">
                Access NextGen Servers in 91 Countries and Connect to our global
                server network.
              </p>
            <div className="row py-5">
                <div className="d-flex">
                <div className="col">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="w-8 h-8"
                >
                  <path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"></path>
                </svg>
                <div className="text-cyan-500 text-[40px] font-bold leading-tight">
                  120<span>+</span>
                </div>
                <div className="font-mono">Locations</div>
              </div>
              <div className="col">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="w-8 h-8"
                >
                  <path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"></path>
                </svg>
                <div className="text-cyan-500 text-[40px] font-bold leading-tight">
                  20<span>+</span>
                </div>
                <div className="font-mono">Countries</div>
              </div>
                </div>
           
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
